export enum TrainingAssignmentStatusEnum {
  ASSIGNED = 'Assigned',
  IN_PROGRESS = 'In Progress',
  COMPLETE = 'Complete',
  UNASSIGNED = 'Unassigned',
  OVERDUE = 'Overdue',
  PENDING_SIGN_OFF = 'Pending SignOff',
}
